import React, { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import TargetFunnelConfiguration from "./RoleTargetFunnelConfiguration";
import TargetFunnelPreview from "./RoleTargetFunnelPreview";
import LeadIndicatorSelection from "./RoleLeadIndicatorSelection";

const RoleInputIndicators = ({ roleId, accountId, onBack }) => {
  const location = useLocation();
  const resolvedRoleId = roleId ?? location.state?.roleId;
  const resolvedAccountId = accountId ?? location.state?.accountId;

  // View state lives in the URL (?view=funnel|preview|leadIndicator) so a
  // page refresh restores the same screen.
  const [searchParams, setSearchParams] = useSearchParams();
  const currentView = searchParams.get("view") || "funnel";

  const setView = (view) => {
    const params = new URLSearchParams(searchParams);
    if (view === "funnel") params.delete("view");
    else params.set("view", view);
    setSearchParams(params, { replace: true, state: location.state });
  };

  const [targetData, setTargetData] = useState(null);
  const [leadIndicatorData, setLeadIndicatorData] = useState(null);

  if (currentView === "preview") {
    return (
      <TargetFunnelPreview
        onBack={() => setView("funnel")}
        onNext={(data) => {
          setLeadIndicatorData(data);
          setView("leadIndicator");
        }}
        targetData={targetData}
        roleId={resolvedRoleId}
        accountId={resolvedAccountId}
      />
    );
  }

  if (currentView === "leadIndicator") {
    return (
      <LeadIndicatorSelection
        onBack={() => setView("preview")}
        roleId={leadIndicatorData?.roleId ?? resolvedRoleId}
        targetFunnelName={leadIndicatorData?.targetFunnelName}
      />
    );
  }

  return (
    <TargetFunnelConfiguration
      onBack={onBack}
      onNext={(data) => {
        setTargetData(data);
        setView("preview");
      }}
      roleId={resolvedRoleId}
      accountId={resolvedAccountId}
    />
  );
};

export default RoleInputIndicators;
